import {
    Channel,
    ChannelGroup,
    ChannelTypes,
} from '../../../../../shared/types';
import { CHANNEL_ORDER_ALL_KEY } from '../../../../../shared/channelOrder';
import { sortByPersistedOrder } from '../../../../../shared/channelSort';
import { ALL_GROUPS, FilterType, SortType, TypeFilter } from '../types';

type GetFilteredChannelsArgs = {
    channels: Channel[];
    hasGroups: boolean;
    channelGroupsWithChannels: ChannelGroup[];
    selectedGroupId: string;
    filterType: FilterType;
};

export const getFilteredChannelsByGroups = ({
    channels,
    hasGroups,
    channelGroupsWithChannels,
    selectedGroupId,
    filterType,
}: GetFilteredChannelsArgs): Channel[] => {
    if (hasGroups) {
        if (selectedGroupId === ALL_GROUPS) {
            return channels;
        }

        const selectedGroup = channelGroupsWithChannels.find(
            (group) => group._id === selectedGroupId
        );
        const groupChannelIds = new Set(selectedGroup?.channelIds || []);

        return channels.filter((channel) => groupChannelIds.has(channel._id));
    }

    return channels.filter((channel) => {
        switch (filterType) {
            case FilterType.Premium:
                return channel.type === ChannelTypes.premium;
            default:
            case FilterType.All:
                return true;
        }
    });
};

export const getFilteredChannelsByType = (
    channels: Channel[],
    typeFilter: TypeFilter
): Channel[] => {
    switch (typeFilter) {
        case TypeFilter.Premium:
            return channels.filter(
                (channel) => channel.type === ChannelTypes.premium
            );
        case TypeFilter.Free:
            return channels.filter(
                (channel) =>
                    channel.type === ChannelTypes.freeOpen ||
                    channel.type === ChannelTypes.freeClosed
            );
        default:
        case TypeFilter.All:
            return channels;
    }
};

export const getSortedChannels = (
    channels: Channel[],
    sortType: SortType,
    selectedGroupId: string
): Channel[] => {
    const sortedChannels = [...channels];

    switch (sortType) {
        case SortType.AZ:
            sortedChannels.sort((a, b) =>
                (a.name || '').localeCompare(b.name || '')
            );
            break;
        case SortType.ZA:
            sortedChannels.sort((a, b) =>
                (b.name || '').localeCompare(a.name || '')
            );
            break;
        default:
        case SortType.None:
            return sortByPersistedOrder(
                sortedChannels,
                selectedGroupId === ALL_GROUPS
                    ? CHANNEL_ORDER_ALL_KEY
                    : selectedGroupId
            );
    }

    return sortedChannels;
};
